import { render, staticRenderFns } from "./LmImportFromExcel.vue?vue&type=template&id=3488153e&scoped=true"
import script from "./LmImportFromExcel.vue?vue&type=script&lang=js"
export * from "./LmImportFromExcel.vue?vue&type=script&lang=js"
import style0 from "./LmImportFromExcel.vue?vue&type=style&index=0&id=3488153e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3488153e",
  null
  
)

export default component.exports